import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const api = new AxiosInterceptor();

export default {
  find(id) {
    return api.get("/plans/" + id);
  },
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get("/plans?" + qstr);
  },
  delete(id) {
    return api.delete("/plans/" + id);
  },
  create(inputs) {
    return api.post("/plans", inputs);
  },
  update(id, inputs) {
    return api.put("/plans/" + id, inputs);
  },
  active(id, inputs) {
    return api.put(`/plans/${id}/active`, inputs);
  },
  getFlexiblePlan() {
    return api.get("/plans/flexible_plan");
  },
  getFlexibleChiller() {
    return api.get("/plans/flexible_chiller_by_admin");
  },
  setFlexiChiller(inputs) {
    return api.put("/plans/set_flexible_chiller", inputs);
  },
  getPlanByType(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get("/plans/get_plan?" + qstr);
  },
  getFixedChiller() {
    return api.get("/plans/fixed_chiller_by_admin");
  },
  setFixedChiller(inputs) {
    return api.put("/plans/set_fixed_chiller", inputs);
  },
  syncPlan(id) {
    return api.post("/plans/" + id + "/sync");
  }
};
